<template>
  <cookie-law>
    <div slot-scope="props">
      <h3 class="cookie-message">Unsere Webseite verwendet Cookies.</h3>
      <p>
        Wir verwenden Cookies und Google Analytics um Ihnen eine bestmögliche Version unserer Webseite zu liefern.
        Cookies werden erst nach Ihrer ausdrücklichen Zustimmung gespeichert.
        <a @click="props.close">
          <router-link :to="{name: 'datenschutz'}" class="text-white">Datenschutzerklärung</router-link>
        </a>
      </p>
      <button
        id="cookie-accept-button"
        class="cookie-button"
        @click="acceptAllCookies(), props.accept()"
      >
        <span>Akzeptieren</span>
      </button>
      <button class="cookie-button" @click="acceptOnlyEssentialCookies(), props.accept()">
        <span>Nur Notwendige</span>
      </button>
      <button class="cookie-close-button" @click="props.close">
        <span>
          <i class="fas fa-times-circle"></i>
        </span>
      </button>
    </div>
  </cookie-law>
</template>

<script>
import CookieLaw from "vue-cookie-law";
import { bootstrap } from "vue-gtag";
export default {
  name: "CookieBanner",
  data() {
    return {};
  },
  methods: {
    acceptAllCookies() {
      document.cookie =
        "eSport_Soccercup_A" +
        "=true; expires=Thu, 31 Dec 2020 23:59:59 UTC; path=/";
      //Enabel Google Analytics
      bootstrap().then(gtag => {});
    },
    acceptOnlyEssentialCookies() {
      document.cookie =
        "eSport_Soccercup_E" +
        "=true; expires=Thu, 31 Dec 2020 23:59:59 UTC; path=/";
    },
    moreInfo() {
      this.$router.push({ name: "datenschutz" }).catch(error => {
        return;
      });
    }
  },
  components: {
    CookieLaw
  }
};
</script>

<style scoped>
h3,
p {
  color: white !important;
}

a {
  color: white;
  text-decoration: underline;
}

.cookie-button {
  margin: 5px;
  padding: 5px 15px;
  border: 1px solid white;
  background: transparent;
  color: white;
}

.cookie-button:active,
.cookie-button:hover,
#cookie-accept-button:hover {
  background: #c04e1a;
  border: 1px solid #c04e1a;
}

.cookie-button:focus {
  outline: none !important;
  box-shadow: none;
}

#cookie-accept-button {
  background: white;
  color: black;
}

.Cookie--base {
  background: #eb6626;
}

.cookie-close-button {
  margin: 5px;
  padding: 5px 15px;
  border: 1px solid white;
  background: transparent;
  color: white;
}

.cookie-close-button:focus {
  outline: none !important;
  box-shadow: none;
}

/*XR*/
@media screen and (width: 828px) and (height: 1792px) {
  h3 {
    font-size: 4.5em !important;
  }
  p {
    font-size: 1.9em !important;
  }

  .cookie-button {
    margin: 30px 15px;
    padding: 10px 20px;
    border: 1px solid white;
    background: transparent;
    color: white;
    font-size: 1.9em;
  }

  .cookie-close-button {
    margin: 30px 15px;
    padding: 10px 20px;
    border: 1px solid white;
    background: transparent;
    color: white;
    font-size: 1.9em;
  }
}
</style>
